module.exports = __webpack_public_path__ + "static/media/globe.ab038ba8.svg";